module.exports = __webpack_public_path__ + "img/message-icon-colored.c5aa577c.svg";